import React from "react";
import { useSelector } from "react-redux";
import { NavLink as NavLinkRRD, useLocation } from "react-router-dom";
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from "reactstrap";
import { Card, Center, Container, Group, Image, Paper, Text } from "@mantine/core";
import { useNavRoutes } from "@/side_menu";
import classnames from "classnames";

import { useScrollDirection } from "@/hooks/UseScrollDirection";
import { useWindow } from "hooks/UseWindow";

import { ReactComponent as UserIcon } from "@/assets/img/avatar.svg";

const HomeNavbar = ({ logo }) => {
	const routes = useNavRoutes();
	const [isOpen, setIsOpen] = React.useState(false);
	const [isShowHeader, setIsShowHeader] = React.useState(true);
	const { scrollDirection } = useScrollDirection();

	const currentUser = useSelector((state) => state.auth?.user?.user);
	const { width } = useWindow();
	const location = useLocation();

	React.useEffect(() => {
		setIsShowHeader(true);
	}, [location]);

	React.useEffect(() => {
		if (scrollDirection === "down") {
			// show header
			setIsShowHeader(true);
		} else if (scrollDirection === "up") {
			setIsShowHeader(false);
		} else if (scrollDirection === "") {
			setIsShowHeader(true);
		}
	}, [scrollDirection]);

	const toggle = () => {
		setIsOpen(!isOpen);
	};

	const activeRoute = (routeName) => {
		return location.pathname.indexOf(routeName) > -1 ? "active" : "";
	};
	return (
		<div className={`main-header-container ${isShowHeader ? "active" : "hidden"}`}>
			<Navbar color="white" light expand="lg" className="shadow p-0 main-header-nav" style={{}}>
				<Container className="nav-container navbar-expand-lg" w="100%">
					{logo ? (
						<NavbarBrand href="/">
							<img alt={logo.imgAlt} className="navbar-logo ml--3" src={logo.imgSrc} href="/" />
						</NavbarBrand>
					) : null}
					<NavbarToggler onClick={toggle} />
					<Collapse
						isOpen={width <= 992 ? isOpen : false}
						navbar
						className="nav-collapse-container">
						<Nav navbar>
							{routes.map((prop, key) => {
								return (
									<NavItem
										className={
											(classnames(activeRoute(prop.layout + prop.path)),
											"py-1 ",
											width <= 992 ? "" : "align-self-center")
										}
										key={key}>
										<NavLink
											to={prop.layout + prop.path}
											className="py-0"
											activeclassname=""
											onClick={toggle}
											tag={NavLinkRRD}
											style={{
												color:
													activeRoute(prop.layout + prop.path) === "active"
														? "rgb(55,132,196)"
														: "#101820",
												transition: "all .5s ease",
												WebkitTransition: "all .5s ease",
												MozTransition: "all .5s ease",
											}}>
											<Text size="sm" fw="normal" c="themed-black.8">
												{prop.name}
											</Text>
										</NavLink>
									</NavItem>
								);
							})}

							{!currentUser && (
								<NavItem className="nav-collapse-navlink-login">
									<NavLink href="/login" className="px-0">
										<UserIcon height={20} width={20} />
									</NavLink>
									<NavLink href="/login" className="pl-2 pr-0">
										Login
									</NavLink>
								</NavItem>
							)}

							{currentUser && (
								<NavItem className="py-1">
									<NavLink to="/profile" className="px-0" tag={NavLinkRRD}>
										<Group gap="xs" align={"center"} justify={"flex-start"}>
											<UserAvatar />
											<Text size="sm" fw="normal" c="themed-black.8" mt="1">
												Profile
											</Text>
										</Group>
									</NavLink>
								</NavItem>
							)}
						</Nav>
					</Collapse>
				</Container>
			</Navbar>
		</div>
	);
};

const UserAvatar = () => {
	const currentUser = useSelector((state) => state.auth?.user?.user);

	if (!currentUser) {
		return null;
	}

	if (!currentUser?.avatar_background_full_image || !currentUser?.avatar_occupation_full_image) {
		return <UserIcon height={20} width={20} />;
	}

	return (
		<Paper
			display={"inline-block"}
			classNames={"fadeInDiv"}
			pos="relative"
			p={0}
			bdrs="100%"
			style={{
				boxShadow: "0px 0px 4px 3px rgba(0, 0, 0, 0.05)",
				overflow: "hidden",
			}}>
			<Image
				h={25}
				w={25}
				fit="contain"
				className={"fadeInDiv"}
				src={currentUser?.avatar_background_full_image}
				style={{
					backgroundSize: "contain",
					backgroundRepeat: "no-repeat",
					aspectRatio: 1,
				}}
			/>
			<Center h="100%" w="100%" top="0" left="0" pos="absolute">
				<Image
					className={"fadeInDiv"}
					h={25}
					w={25}
					style={{
						objectFit: "contain",
						aspectRatio: 1,
					}}
					fit="contain"
					alt={"display_occupation"}
					src={currentUser?.avatar_occupation_full_image}
				/>
			</Center>
		</Paper>
	);
};

export default HomeNavbar;
